function loadGearboxViewer(shell) {
  if (!shell || shell.dataset.loaded === 'true') return;

  const template = shell.querySelector('[data-gearbox-srcdoc]');
  const frame = shell.querySelector('[data-gearbox-frame]');
  const stage = shell.querySelector('.vw-model__stage');

  if (!template || !frame || !stage) return;

  shell.dataset.loaded = 'true';
  frame.addEventListener('load', () => {
    shell.dataset.ready = 'true';
  }, { once: true });

  frame.srcdoc = template.innerHTML.trim();
  frame.hidden = false;
  stage.classList.add('is-loaded');
}

function setupGearboxViewers() {
  document.querySelectorAll('[data-autoload-viewer]').forEach((shell) => {
    loadGearboxViewer(shell);
  });

  const deferred = Array.from(document.querySelectorAll('[data-defer-viewer]'));
  if (!deferred.length) return;

  const loadVisibleDeferred = () => {
    deferred.forEach((shell) => {
      if (shell.dataset.loaded === 'true') return;
      const rect = shell.getBoundingClientRect();
      if (rect.top < window.innerHeight + 120 && rect.bottom > -120) {
        loadGearboxViewer(shell);
      }
    });

    if (deferred.every((shell) => shell.dataset.loaded === 'true')) {
      window.removeEventListener('scroll', loadVisibleDeferred);
      window.removeEventListener('resize', loadVisibleDeferred);
    }
  };

  window.addEventListener('scroll', loadVisibleDeferred, { passive: true });
  window.addEventListener('resize', loadVisibleDeferred);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupGearboxViewers, { once: true });
} else {
  setupGearboxViewers();
}
